require('./styleguide');
require('./bootstrap-modal');
require('./bond-calculator');
require('./enquire-card');
require('./transfer-calculator');
require('./navigation');
require('./forms');
require('./search/basic');
require('./search/advanced');
require('./suburb-autocomplete');
require('./number-inputs');
require('./form-recaptcha-button');
require('./win-luxury');
// require('./greeting');

window.dd = function () {
    console.log.apply(console, arguments);
};

window.trackGa = function (action, category = 'Click', label = null, value = null) {
    let obj = {
        event_category: category,
    };

    if (label) {
        obj.event_label = label;
    }

    if (value) {
        obj.value = value;
    }

    dd('gtag', action, obj);

    try {
        gtag('event', action, obj);
    } catch (error) {
        console.error('Failed to ga', error);
    }
};

import 'lazysizes';

const $ = require('jquery');
const $alert = $('.box .alert-wrapper.js-alert');
if ($alert.length > 0) {
    $alert.appendTo('main');
}

// Lazyload helper for bg-images
document.addEventListener('lazybeforeunveil', function (e) {
    var bg = e.target.getAttribute('data-bg');
    if (bg) {
        e.target.style.backgroundImage = 'url(' + bg + ')';
    }
});

const Vue = require('vue').default;
if (document.getElementById('app')) {
    window._ = require('lodash');

    Vue.component('find-office-map', require('./components/FindOfficeMap.vue').default);
    Vue.component('virtual-valuation-form', require('./components/VirtualValuationForm.vue').default);

    new Vue({
        el: '#app',
    });
}
